import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChanges: {
        id: 'premier.policychange.perLine.views.policyChangesPage.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    policyChangeEffectiveDate: {
        id: 'premier.policychange.perLine.views.policyChangesPage.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    description: {
        id: 'premier.policychange.perLine.views.policyChangesPage.Description:',
        defaultMessage: 'Description:'
    },
    secondaryNamedInsured: {
        id: 'premier.policychange.perLine.views.policyChangesPage.Secondary Named Insured',
        defaultMessage: 'Secondary Named Insured'
    },
    add: {
        id: 'premier.policychange.perLine.views.policyChangesPage.Add',
        defaultMessage: 'Add'
    },
    address: {
        id: 'premier.policychange.perLine.views.policyChangesPage.Address',
        defaultMessage: 'Address'
    },
    policyType: {
        id: 'premier.policychange.perLine.views.policyChangesPage.PolicyType.label',
        defaultMessage: 'What policy type is this associated with?'
    },
    baseState: {
        id: 'premier.policychange.perLine.views.policyChangesPage.BaseState',
        defaultMessage: 'Base State'
    },
    riskType: {
        id: 'premier.policychange.perLine.views.policyChangesPage.riskType',
        defaultMessage: 'Risk Type'
    },
});
